import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import Select from 'react-select';
import moment from 'moment';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import {
  setInsightsCriteriaDateRange,
  setInsightsCriteriaOrganisation,
  setInsightsCriteriaType,
  setInsightsCriteriaSubcategory,
  clearInsightsCriteriaBoundaries,
  clearInsightsCriteriaPois,
} from '../store/actions/criteria-actions';

import { setSelectedReportById } from '../store/actions/report-actions';
import { setLastInsightPage } from '../store/actions/route-actions';

import {
  getTravelPastSummary,
  getTravelPastPoiCount,
  getTravelPastOverTime,
  getTravelPastDailyAverages,
  getTravelPastPois,
  getTravelPastRepeatDevices,
  selectTravelPastAverage,
  loadTravelPastMockData,
  downloadTravelPast,
  selectTravelPastTimePeriod,
} from '../store/actions/travel-past-actions';

import Header from './Header';
import HomeInsightSidebar from './HomeInsightSidebar';
import InsightsNavBar from './InsightsNavBar';
import SVGIcon from '../components/SVGIcon';
import LoadingContainer from '../components/LoadingContainer';
import TravelPastByTheHourGraph from '../components/TravelPastByTheHourGraph';
import TravellingPastUniqueVsRepeat from '../components/TravellingPastUniqueVsRepeat';
import SelectionNotAvailable from '../components/SelectionNotAvailable';
import CopyrightAndVersion from '../components/CopyrightAndVersion';
import CriteriaModalWrapper from '../components/CriteriaModalWrapper';
import BarGraph from '../components/BarGraph';
import DownloadPdf from '../components/DownloadPdf';
import DownloadCSVButton from '../components/DownloadCSVButton';

import {
  formatNumber,
  isEmptyObject,
  isDataAvailable,
  searchStringInObjectArray,
} from '../utilities/helpers';

import {
  validateReportCriteria,
  chooseDownloadableBtn,
  insertTitle,
  insertSubTile,
  checkDefaultTab,
} from '../utilities/report-helpers';

const mapStateToProps = (
  { insightsCriteria, travelPast, client, reports, locations, auth },
  ownProps
) => ({
  ...insightsCriteria,
  ...travelPast,
  organisations: reports.reportDictionary[ownProps.reportId].organisation,
  report: reports.reportDictionary[ownProps.reportId],
  insightType: insightsCriteria.insightType,
  client,
  ...locations,
  ableToDownloadCSV: chooseDownloadableBtn(
    'travelPast',
    auth.tokenPayload.scopes,
    insightsCriteria.insightType,
    travelPast
  ),
  organisationsAvailable:
    reports.reportDictionary &&
    reports.reportDictionary[ownProps.reportId] &&
    reports.reportDictionary[ownProps.reportId].organisationsAvailable,
  geographyAvailable:
    reports.reportDictionary &&
    reports.reportDictionary[ownProps.reportId] &&
    reports.reportDictionary[ownProps.reportId].geographyAvailable,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      setInsightsCriteriaDateRange,
      setInsightsCriteriaOrganisation,
      getTravelPastSummary,
      getTravelPastPoiCount,
      getTravelPastOverTime,
      getTravelPastDailyAverages,
      getTravelPastPois,
      getTravelPastRepeatDevices,
      loadTravelPastMockData,
      selectTravelPastAverage,
      setSelectedReportById,
      setInsightsCriteriaType,
      setInsightsCriteriaSubcategory,
      clearInsightsCriteriaBoundaries,
      clearInsightsCriteriaPois,
      downloadTravelPast,
      selectTravelPastTimePeriod,
      setLastInsightPage
    },
    dispatch
  );

class TravellingPastInsights extends React.Component {
  state = {
    sideBarOpen: true,
    showSelectionWarning: false,
    selectionWarningText: '',
    selectionWarningButtonText: '',
    averages: [],
    selectedAverage: {},
    showCriteriaModal: false,
    timePeriodArray: [],
    currentTimePeriod: this.props.selectedPeriod,
  };

  componentDidMount() {
    this.props.setLastInsightPage('/travelling-past-insights');
    this.props.clearInsightsCriteriaPois();

    const selectedTab = checkDefaultTab(
      this.props.reportsType,
      this.props.insightType,
      this.props.geographyAvailable,
      this.props.organisationsAvailable
    );
    this.props.setInsightsCriteriaType(selectedTab);

    this.props.setSelectedReportById(this.props.reportId);
    this.populateDatePeriodAndMonthsDropDown();
    // validate before getdata
    const validateResult = this.handelValidateReportCriteria(selectedTab);
    validateResult.showSelectionWarning === false && this.loadData('');
  }

  componentDidUpdate = prevProps => {
    if (prevProps.criteriaId !== this.props.criteriaId) {
      // validate before getdata
      const selectedTab = checkDefaultTab(
        this.props.reportsType,
        this.props.insightType,
        this.props.geographyAvailable,
        this.props.organisationsAvailable
      );
      const validateResult = this.handelValidateReportCriteria(selectedTab);

    }
  };

  populateDatePeriodAndMonthsDropDown = () => {
    // Ticket issue #392
    let datePeriod = this.props.report.props.datePeriod.concat();
    // filter enable === false
    datePeriod = datePeriod.filter(o => o.enable === true);

    const excuteDefaultSelection = targetObj => {
      let datePart = targetObj.datePart;
      // filter unable datePart
      datePart = datePart.filter(o => o.enable === true);

      this.setState(() => ({
        currentTimePeriod: targetObj,
        averages: datePart,
      }));
      this.props.selectTravelPastTimePeriod(targetObj);

      // average part condition, monthly first. If not, go for the first ele of array
      const hasMonthlyObj = datePart.find(o => o.value === 'month');
      if (hasMonthlyObj === undefined) {
        this.setState(() => ({ selectedAverage: datePart[0] }));
        this.props.selectTravelPastAverage(datePart[0]);
      } else {
        this.setState(() => ({ selectedAverage: hasMonthlyObj }));
        this.props.selectTravelPastAverage(hasMonthlyObj);
      }
    };

    if (datePeriod !== undefined && datePeriod.length > 0) {
      this.setState(() => ({ timePeriodArray: datePeriod }));
      const has90DaysObj = datePeriod.find(o => o.value === 90);
      has90DaysObj === undefined
        ? excuteDefaultSelection(datePeriod[0])
        : excuteDefaultSelection(has90DaysObj);
    }
  };

  handleSelectTravelPastAverage = e => {
    this.props.selectTravelPastAverage(e);
    this.loadData();
    this.setState(() => ({ selectedAverage: e }));
  };

  handelValidateReportCriteria = selectedTab => {
    const reportCriteriaValid = validateReportCriteria({
      insightType: selectedTab,
      report: this.props.report,
      subcategory: this.props.subcategory,
      organisation: this.props.organisation,
    });

    this.setState(() => ({
      ...reportCriteriaValid,
    }));
    return reportCriteriaValid;
  };

  loadData = () => {
    this.props.getTravelPastSummary();
    this.props.getTravelPastOverTime();
    this.props.getTravelPastDailyAverages();
    this.props.getTravelPastPois();
    this.props.getTravelPastRepeatDevices();
    this.props.getTravelPastPoiCount();
    // this.props.loadTravelPastMockData();
  };

  changeArraytoString = selectedArray =>
    selectedArray.map(item => item.label).join(' + ');

  isOutsideRangeHandler = selectedDate =>
    !selectedDate.isSameOrBefore(moment()) ||
    !selectedDate.isSameOrAfter(moment(this.props.client.firstEventTS));

  toggleSideBar = () =>
    this.setState(prevState => ({ sideBarOpen: !prevState.sideBarOpen }));

  openCriteriaModal = () => this.setState(() => ({ showCriteriaModal: true }));
  closeCriteriaModal = () =>
    this.setState(() => ({ showCriteriaModal: false }));

  handleTimePeriod = e => {
    let availableDatePart = e.datePart;
    // filter unable datePart
    availableDatePart = availableDatePart.filter(o => o.enable === true);

    this.setState({
      currentTimePeriod: e,
      averages: availableDatePart,
      selectedAverage: availableDatePart[0],
    });
    this.props.selectTravelPastAverage(availableDatePart[0]);
    this.props.selectTravelPastTimePeriod(e);
    this.loadData();
  };

  summaryCardRender = () => {
    const firstSummary =
      this.props.client.accountType === 'collects' ? (
        <div className="content-card">
          <span className="FootfallInsights_main_top_cards_info">
            {this.props.summaryData.eventsCount &&
              formatNumber(this.props.summaryData.eventsCount)}
          </span>
          location records
        </div>
      ) : (
        <div className="content-card">
          <span className="FootfallInsights_main_top_cards_info">
            {this.renderFirstSummaryCard()}
          </span>
          are the panel
        </div>
      );

    const secondSummary =
      this.props.client.accountType === 'collects' ? (
        <div className="content-card">
          <span className="FootfallInsights_main_top_cards_info">
            {this.props.summaryData.devicesCount &&
              formatNumber(this.props.summaryData.devicesCount)}
          </span>
          unique devices
        </div>
      ) : (
        <div className="content-card">
          <span className="FootfallInsights_main_top_cards_info">95%</span>
          confidence level
        </div>
      );

    return (
      <div className="FootfallInsights_main_top_cards">
        {firstSummary}
        {secondSummary}

        <div className="content-card">
          <span className="FootfallInsights_main_top_cards_info">
            {this.props.travelPastPoiCountData.poisCount !== undefined &&
            this.props.travelPastPoiCountData.poisCount !== null
              ? formatNumber(this.props.travelPastPoiCountData.poisCount)
              : 0}
          </span>

          {this.props.travelPastPoiCountData.poisCount &&
          this.props.travelPastPoiCountData.poisCount > 1
            ? `points of interest`
            : `point of interest `}
        </div>
      </div>
    );
  };

  renderFirstSummaryCard = () => {
    const { adm0, adm2, adm3, adm4, poiId, boundariesDictionary } = this.props;
    const foundIndex = [adm0, adm2, adm3, adm4, poiId].findIndex(
      element => element !== null
    );

    const selectedBoundary = adm0 || adm2 || adm3 || adm4 || poiId;

    if (selectedBoundary === null || selectedBoundary === undefined) {
      // none boundary be choosed

      return boundariesDictionary.country && boundariesDictionary.country.areas
        ? `${boundariesDictionary.country.areas[0].name} devices`
        : `Country devices ${(<br />)}`;
    } else if (Array.isArray(selectedBoundary) && selectedBoundary.length > 1) {
      // multiple boundary be choosed

      return `Devices from Mutilple Districts / Major Cities`;
    }
    // only one boundary be choosed

    if (selectedBoundary === poiId && selectedBoundary[0].place) {
      return `${selectedBoundary[0].place} devices`;
    }

    if(selectedBoundary[0].label === "All Regional" || selectedBoundary[0].label === "All Metro" )
      return `${selectedBoundary[0].label} devices`

    return foundIndex === 1 || foundIndex === 2
      ? `${selectedBoundary[0].label.substring(
          0,
          selectedBoundary[0].label.indexOf(',')
        )} devices`
      : `${selectedBoundary[0].label.substring(
          selectedBoundary[0].label.indexOf(',') + 1
        )} devices`;
  };

  dailyAveragesPreProcess() {
    if (!isEmptyObject(this.props.dailyAveragesData)) {
      const dataObj = this.props.dailyAveragesData.percent;
      return Object.keys(dataObj).map(key => ({
        name: key,
        sharePerCent: dataObj[key],
      }));
    }
  }

  render() {
    let travellingPastUVR;
    if (this.props.repeatDevicesData) {
      travellingPastUVR = (
        <TravellingPastUniqueVsRepeat
          repeatPercent={this.props.repeatDevicesData.repeatPercent}
          uniquePercent={this.props.repeatDevicesData.uniquePercent}
          averageEvents={this.props.repeatDevicesData.averageEvents}
          averageEventsByPOI={this.props.repeatDevicesData.averageEventsByPOI}
          clientId={this.props.client.id}
        />
      );
    } else {
      travellingPastUVR = <div>Awaiting data.</div>;
    }

    return (
      <div className="FootfallInsights" data-html2canvas-ignore="true">
        <Header />
        {this.state.sideBarOpen && (
          <HomeInsightSidebar
            loadData={this.loadData}
            toggleSideBar={this.toggleSideBar}
            reportId={this.props.reportId}
            reportsType="TravelPast"
          />
        )}
        <main
          className={`FootfallInsights_main${
            this.state.sideBarOpen ? '' : ' FootfallInsights_main_full-width'
          }`}
        >
          {!this.state.sideBarOpen && (
            <button
              className="FootfallInsights_main_open-side-bar-button"
              onClick={this.toggleSideBar}
            >
              <SVGIcon icon="back-arrow" />
            </button>
          )}
          <div className="FootfallInsights_main_top">
            <div className="container">
              <div className="FootfallInsights_title-bar">
                <div className="FootfallInsights_title-bar_left">
                  <h1>
                    {insertTitle(this.props, this.state.showSelectionWarning)}
                  </h1>
                  <h3>
                    {insertSubTile(this.props, this.state.showSelectionWarning)}
                  </h3>
                </div>
                <div className="FootfallInsights_date-range-group">
                  <Select
                    inputId="category"
                    className="FootfallInsights_time-period-selection"
                    placeholder="Type to search"
                    isDisabled={false}
                    isLoading={false}
                    isRtl={false}
                    isSearchable
                    name="category"
                    options={this.state.timePeriodArray}
                    onChange={this.handleTimePeriod}
                    value={this.state.currentTimePeriod}
                  />

                  <Select
                    options={this.state.averages}
                    className="FootfallInsights_select"
                    value={this.state.selectedAverage}
                    onChange={this.handleSelectTravelPastAverage}
                  />

                  {Array.isArray(this.props.ableToDownloadCSV) &&
                    this.props.ableToDownloadCSV.length > 0 &&
                    this.props.client.props.enableAudienceBuilder !== true && (
                      <DownloadCSVButton
                        downloadAudience={this.props.downloadTravelPast}
                        downloadingCSV={this.props.downloadingCSV}
                        label="Download audience .csv"
                        reportType="travelPast"
                        insightType={this.props.insightType}
                        ableToDownloadCSV={this.props.ableToDownloadCSV}
                      />
                    )}
                </div>
              </div>
              <div>
                {!this.state.showSelectionWarning && (
                  <LoadingContainer
                    loading={
                      !(
                        this.props.summaryLoaded === true &&
                        this.props.travelPastPoiCountLoaded === true
                      )
                    }
                  >
                    {this.summaryCardRender()}
                  </LoadingContainer>
                )}
              </div>
            </div>
          </div>
          <div className="FootfallInsights_reports container">
            <InsightsNavBar selectedReport={this.props.reportId} />
            {this.state.showSelectionWarning ? (
              <SelectionNotAvailable
                text={this.state.selectionWarningText}
                buttonText={this.state.selectionWarningButtonText}
                openCriteriaModal={this.openCriteriaModal}
                wholePage
              />
            ) : (
              <div className="FootfallInsights_reports_tab-panel">
                <div className="FootfallInsights_reports_grid">
                  <LoadingContainer
                    loading={!this.props.overTimeLoaded}
                    className="FootfallInsights_reports_grid_top content-card"
                  >
                    <TravelPastByTheHourGraph
                      data={this.props.overTimeData}
                      unit={undefined}
                      title="Travelling past by the hour"
                      setUnit={this.setFootFallOverTimeUnit}
                      footfallName={`${this.props.title} footfall`}
                      baslineName={`${
                        this.props.insightType === 'category'
                          ? this.props.client && this.props.client.name
                          : this.props.subcategory &&
                            this.props.subcategory.label
                      } average`}
                      downloadOpen={searchStringInObjectArray(
                        'over-time',
                        this.props.ableToDownloadCSV,
                        'value'
                      )}
                      downloadAudience={this.props.downloadTravelPast}
                      reportType="travelPast"
                      insightType={this.props.insightType}
                      downloadingCSV={this.props.downloadingCSV}
                    />
                  </LoadingContainer>
                  <LoadingContainer
                    loading={!this.props.dailyAveragesLoaded}
                    className="FootfallInsights_reports_grid_left content-card"
                  >
                    <BarGraph
                      data={
                        this.props.dailyAveragesData
                          ? this.dailyAveragesPreProcess()
                          : []
                      }
                      isDataAvailable={isDataAvailable(
                        this.props.dailyAveragesData
                      )}
                      title="Daily averages"
                      barOnScreen={7}
                      downloadOpen={searchStringInObjectArray(
                        'daily-averages',
                        this.props.ableToDownloadCSV,
                        'value'
                      )}
                      downloadAudience={this.props.downloadTravelPast}
                      reportType="travelPast"
                      insightType={this.props.insightType}
                      downloadingCSV={this.props.downloadingCSV}
                    />
                  </LoadingContainer>
                  <LoadingContainer
                    loading={!this.props.repeatDevicesLoaded}
                    className="FootfallInsights_reports_grid_right content-card"
                  >
                    <h3 className="content-card_title">Repeat vs Unique</h3>
                    {travellingPastUVR}
                  </LoadingContainer>

                  <LoadingContainer
                    loading={!this.props.poisLoaded}
                    className="FootfallInsights_reports_grid_bottom content-card"
                  >
                    <BarGraph
                      data={this.props.poisData ? this.props.poisData : []}
                      isDataAvailable={isDataAvailable(this.props.poisData)}
                      title="Travelling past a point of interest"
                      barOnScreen={10}
                      buttonOpen
                      downloadOpen={searchStringInObjectArray(
                        'pois',
                        this.props.ableToDownloadCSV,
                        'value'
                      )}
                      downloadAudience={this.props.downloadTravelPast}
                      reportType="travelPast"
                      insightType={this.props.insightType}
                      downloadingCSV={this.props.downloadingCSV}
                    />
                  </LoadingContainer>
                </div>
              </div>
            )}
          </div>
          <div className="FootfallInsights_DownlaodPdf">
            <DownloadPdf
              reportType="TravellingPast"
              isDisabled={
                !(
                  this.props.poisLoaded &&
                  this.props.repeatDevicesLoaded &&
                  this.props.dailyAveragesLoaded &&
                  this.props.overTimeLoaded &&
                  this.props.summaryLoaded &&
                  !this.state.showSelectionWarning
                )
              }
            />
            <CopyrightAndVersion />
          </div>
        </main>
        <CriteriaModalWrapper
          isOpen={this.state.showCriteriaModal}
          close={this.closeCriteriaModal}
          reportId={this.props.reportId}
        />
      </div>
    );
  }
}

TravellingPastInsights.propTypes = {
  report: PropTypes.object.isRequired, // eslint-disable-line
  client: PropTypes.object.isRequired, // eslint-disable-line
  insightType: PropTypes.string,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  organisation: PropTypes.object, // eslint-disable-line
  subcategory: PropTypes.object, // eslint-disable-line
  getTravelPastSummary: PropTypes.func.isRequired,
  getTravelPastOverTime: PropTypes.func.isRequired,
  getTravelPastPois: PropTypes.func.isRequired,
  getTravelPastRepeatDevices: PropTypes.func.isRequired,
  summaryLoaded: PropTypes.bool.isRequired,
  summaryData: PropTypes.shape({
    eventsCount: PropTypes.number,
    devicesCount: PropTypes.number,
    poisCount: PropTypes.number,
    poisTotalCount: PropTypes.number,
  }).isRequired,
  overTimeLoaded: PropTypes.bool.isRequired,
  overTimeData: PropTypes.arrayOf(PropTypes.object).isRequired,
  dailyAveragesLoaded: PropTypes.bool.isRequired,
  dailyAveragesData: PropTypes.shape({
    Mon: PropTypes.number,
    Tue: PropTypes.number,
    Wed: PropTypes.number,
    Thu: PropTypes.number,
    Fri: PropTypes.number,
    Sat: PropTypes.number,
    Sun: PropTypes.number,
    percent: PropTypes.shape({
      Mon: PropTypes.number,
      Tue: PropTypes.number,
      Wed: PropTypes.number,
      Thu: PropTypes.number,
      Fri: PropTypes.number,
      Sat: PropTypes.number,
      Sun: PropTypes.number,
    }),
  }).isRequired,
  repeatDevicesLoaded: PropTypes.bool.isRequired,
  poisLoaded: PropTypes.bool.isRequired,
  poisData: PropTypes.arrayOf(PropTypes.object).isRequired,
  repeatDevicesData: PropTypes.shape({
    repeatPercent: PropTypes.number,
    uniquePercent: PropTypes.number,
    averageEvents: PropTypes.number,
    averageEventsByPOI: PropTypes.number,
  }).isRequired,
  reportId: PropTypes.string.isRequired,
  criteriaId: PropTypes.string.isRequired,
  setSelectedReportById: PropTypes.func.isRequired,
  clearInsightsCriteriaBoundaries: PropTypes.func.isRequired,
};

TravellingPastInsights.defaultProps = {
  organisation: null,
  subcategory: null,
  insightType: 'organisation',
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TravellingPastInsights);
